"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalStorage {
    constructor(baseKey) {
        this.setItem = (key, data) => {
            if (!this.checkStorage()) {
                return null;
            }
            window.localStorage.setItem(`${this.baseKey}/${key}`, JSON.stringify(data));
        };
        this.getItem = (key) => {
            if (!this.checkStorage()) {
                return null;
            }
            const value = window.localStorage.getItem(`${this.baseKey}/${key}`);
            if (!value) {
                return null;
            }
            else {
                try {
                    return JSON.parse(value);
                }
                catch (e) {
                    return null;
                }
            }
        };
        this.removeItem = (key) => {
            if (!this.checkStorage()) {
                return null;
            }
            window.localStorage.removeItem(`${this.baseKey}/${key}`);
        };
        this.baseKey = baseKey;
    }
    checkStorage() {
        return typeof window !== 'undefined' && typeof (window.localStorage) === 'object' && window.localStorage !== null;
    }
}
exports.LocalStorage = LocalStorage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN0b3JhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFVQSxNQUFhLFlBQVk7SUFFckIsWUFBWSxPQUFlO1FBSXBCLFlBQU8sR0FBRyxDQUFJLEdBQVcsRUFBRSxJQUFPLEVBQUUsRUFBRTtZQUMzQyxJQUFJLENBQUMsSUFBSSxDQUFDLFlBQVksRUFBRSxFQUFFO2dCQUN4QixPQUFPLElBQUksQ0FBQzthQUNiO1lBQ0QsTUFBTSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsR0FBRyxJQUFJLENBQUMsT0FBTyxJQUFJLEdBQUcsRUFBRSxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztRQUM5RSxDQUFDLENBQUE7UUFDTSxZQUFPLEdBQUksQ0FBSSxHQUFXLEVBQUUsRUFBRTtZQUNuQyxJQUFJLENBQUMsSUFBSSxDQUFDLFlBQVksRUFBRSxFQUFFO2dCQUN4QixPQUFPLElBQUksQ0FBQzthQUNiO1lBQ0QsTUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsR0FBRyxJQUFJLENBQUMsT0FBTyxJQUFJLEdBQUcsRUFBRSxDQUFDLENBQUM7WUFDcEUsSUFBSSxDQUFDLEtBQUssRUFBRTtnQkFDVixPQUFPLElBQUksQ0FBQzthQUNiO2lCQUFNO2dCQUNMLElBQUk7b0JBQ0YsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBTSxDQUFDO2lCQUMvQjtnQkFBQyxPQUFPLENBQUMsRUFBRTtvQkFDVixPQUFPLElBQUksQ0FBQztpQkFDYjthQUVGO1FBQ0gsQ0FBQyxDQUFBO1FBQ00sZUFBVSxHQUFHLENBQUMsR0FBVyxFQUFFLEVBQUU7WUFDbEMsSUFBSSxDQUFDLElBQUksQ0FBQyxZQUFZLEVBQUUsRUFBRTtnQkFDeEIsT0FBTyxJQUFJLENBQUM7YUFDYjtZQUNELE1BQU0sQ0FBQyxZQUFZLENBQUMsVUFBVSxDQUFDLEdBQUcsSUFBSSxDQUFDLE9BQU8sSUFBSSxHQUFHLEVBQUUsQ0FBQyxDQUFDO1FBQzNELENBQUMsQ0FBQTtRQTlCQyxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztJQUN6QixDQUFDO0lBK0JPLFlBQVk7UUFDbEIsT0FBUSxPQUFPLE1BQU0sS0FBSyxXQUFXLElBQUksT0FBTyxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsS0FBSyxRQUFRLElBQUksTUFBTSxDQUFDLFlBQVksS0FBSyxJQUFJLENBQUM7SUFDckgsQ0FBQztDQUVGO0FBdkNILG9DQXVDRyJ9